import { SYNC_KEY_PROYECTOS_FASES } from "../../../constantes";
import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { FaseResponse } from "../../../shared/response/proyectos/FaseResponse";
import { ServiceGetListBase } from "../../../shared/services/base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** Fases del ciclo del proyecto (F0/F1/F2). Solo lectura: sin pantalla de edición, son 3 filas fijas. */
export class FaseService extends ServiceGetListBase<FaseResponse> {
  static readonly instance = new FaseService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_PROYECTOS_FASES;
  protected readonly sortBy = "orden";

  /** gRPC-Web (`ListFases`): no eliminadas, por orden. */
  protected async fetchItems(): Promise<FaseResponse[]> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).listFases({}));
    return r.items.map((f) => ({
      id: f.id,
      isEliminado: false,
      codigo: f.codigo,
      nombre: f.nombre,
      tipo: f.tipo as FaseResponse["tipo"],
      orden: f.orden,
      mesInicio: f.mesInicio,
      mesFin: f.mesFin,
      activo: f.activo,
    }));
  }
}
